import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import SectionContainer from '../shared/SectionContainer';
import FlowStep from '../shared/FlowStep';
import { HOW_IT_WORKS_STEPS } from '../landingContent';
import useScrollReveal from '../hooks/useScrollReveal';

const HowItWorksSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { ref, className } = useScrollReveal('fade-in');

  return (
    <SectionContainer
      id="how-it-works"
      title="How It Works"
      subtitle="From job posting to hire — one connected platform for recruiters and candidates."
      titleId="how-it-works-heading"
    >
      <Box
        ref={ref}
        className={className}
        sx={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: isMobile ? 3 : 2,
          alignItems: isMobile ? 'stretch' : 'flex-start',
        }}
      >
        {HOW_IT_WORKS_STEPS.map((step, index) => (
          <FlowStep
            key={step.title}
            stepNumber={index + 1}
            title={step.title}
            description={step.description}
            isLast={index === HOW_IT_WORKS_STEPS.length - 1}
            vertical={isMobile}
          />
        ))}
      </Box>
    </SectionContainer>
  );
};

export default HowItWorksSection;
